import { SideBarObjects as adminSideBarObjects } from 'components/pages/config/AdminSideBarObjects';

exports.SideBarObjects = [
    {
        name: 'Home',
        icon: 'icon-home',
        path: '/dashboard'
    },
    ...adminSideBarObjects,
    {
        name: 'Glossary',
        icon: 'icon-glossary',
        path: '/dashboard/glossary'
    },
];



// WEBPACK FOOTER //
// ./src/components/pages/config/HomeSideBarObjects.js